module.exports = "/images/logo-aloindex.svg?1a3fa98a7b9f2869b8e16680bbf0c6b3";